import { ApolloClient } from '@apollo/client';
import { FunnelCart } from 'src/ts/types/cart';
import { EMPTY_CART_DELIVERY } from 'src/graphql-operations/cart-order-service/carts.mutation';
import { ClientNames } from 'src/utils/apolloClient';

type EmptyCartDeliveryResult =
  | { success: true; cart: FunnelCart }
  | { success: false; error: 'STATUS_ERROR' | 'UNKNOWN' };

interface EmptyCartDeliveryMutation {
  emptyCartDelivery: {
    __typename: 'CartDelivery' | 'CartError';
    cart?: FunnelCart;
    validation?: {
      status?: { message: string }[];
      quantity?: { message: string; deliveryId: number }[];
    };
  };
}

export async function emptyCartDelivery(input: {
  apolloClient: ApolloClient;
  cartUUID: string;
  cartDeliveryId: number;
}): Promise<EmptyCartDeliveryResult> {
  const { apolloClient, cartUUID, cartDeliveryId } = input;

  const { data } = await apolloClient.mutate<EmptyCartDeliveryMutation>({
    mutation: EMPTY_CART_DELIVERY,
    context: { clientName: ClientNames.CART_ORDER_GRAPH },
    variables: { cartUUID, cartDeliveryId },
  });

  const response = data?.emptyCartDelivery;

  if (!response) {
    return { success: false, error: 'UNKNOWN' };
  }

  if (response.__typename === 'CartDelivery') {
    return { success: true, cart: response.cart! };
  }

  if (response.__typename === 'CartError') {
    if (response.validation?.status?.length) {
      return { success: false, error: 'STATUS_ERROR' };
    }
  }

  return { success: false, error: 'UNKNOWN' };
}
